export function clearLocalStorage(localStorageKey) {
  try {
    localStorageKey && localStorage.removeItem(localStorageKey)
  } catch (e) {
    // do nothing
  }
}

export function saveToLocalStorage(localStorageKey, data) {
  try {
    localStorageKey && localStorage.setItem(localStorageKey, JSON.stringify(data))
  } catch (e) {
    // do nothing
  }
}

export function loadFromLocalStorage(localStorageKey, defaultValue = null) {
  try {
    const value = localStorage.getItem(localStorageKey)
    if (typeof value === 'string') {
      return JSON.parse(value || 'null')
    }
  } catch (e) {}
  return defaultValue
}

export function getLocalStorageKeys() {
  try {
    return Object.keys(localStorage)
  } catch (e) {}
  return []
}
